/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useRef, useState } from 'react'
import * as auth from '../../api/auth/auth'
import jwt from 'jsonwebtoken'

import IconClose from '../../assets/icons/icon-close.svg'
import IconProfile from '../../assets/icons/icon-profile.svg'

import * as S from './styles'
import { Link } from 'react-router-dom'
import { isPromotor } from '../MenuProfile/sideMenuUtils'
import IconArrowLeft from '../../assets/img/icon-arrow-left.svg'
import IconArrowRight from '../../assets/img/icon-arrow-right.svg'
import IconDiamond from '../../assets/img/icon-diamond.svg'
import { useSelector } from 'react-redux'
import { UserContext } from '../../contexts/UserContext'

const MenuMobile = ({ showMenu, setShowMenu, categories }) => {
  const modalRef = useRef()

  const closeMenu = (e) => {
    if (modalRef.current === e.target) {
      setShowMenu(false)
    }
  }

  const [isCategMenuOpen, setIsCategMenuOpen] = useState(true)
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false)
  const [isCategSubmenuOpen, setIsCategSubmenuOpen] = useState(false)
  const [arraySubCategories, setOpenSubCategories] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [activeLink, setActiveClass] = useState(1)

  const store = useSelector((reduxState) => reduxState)
  const { user } = useContext(UserContext)

  // useEffect(() => {
  //   // fetchUser(setUserData)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  // const logged = auth.isAuthenticated()
  const logged = auth.isAuthenticated()
  const token = auth.getToken()
  const userLogged = jwt.decode(token)

  const openSubCategories = () => {
    if (isCategMenuOpen) {
      setIsCategMenuOpen(false)
      setIsCategSubmenuOpen(true)
    }
  }

  const closeSubCategories = () => {
    if (isCategSubmenuOpen) {
      setIsCategSubmenuOpen(false)
      setIsCategMenuOpen(true)
    }
  }

  const openProfileMenu = () => {
    setIsProfileMenuOpen(true)
  }

  const handleClick = (activeLink, arraySubCategories) => {
    setActiveClass(activeLink)
    setOpenSubCategories(arraySubCategories)
  }

  return (
    <>
      {showMenu ? (
        <S.Modal onClick={closeMenu}>
          <S.MenuMobileContent>
            <S.CloseModal onClick={() => setShowMenu((prev) => !prev)}>
              <img src={IconClose} alt="" />
            </S.CloseModal>
            <S.MenuMobileBox>
              <S.MenuMobileHeader>Menu</S.MenuMobileHeader>
              {logged ? (
                <S.Account>
                  <S.HeaderNavigationItemLink onClick={openProfileMenu}>
                    {/* <img
                      src={UserImg}
                      alt="foto de perfil do usuário"
                      className="profile-img"
                    /> */}
                    Olá,{' '}
                    <strong style={{ marginLeft: 4 }}>
                      {userLogged.userNameWelcome}
                    </strong>
                  </S.HeaderNavigationItemLink>
                </S.Account>
              ) : (
                <S.Account>
                  <S.HeaderNavigationItemLink>
                    {/* <Icon name="icon-profile" /> */}
                    <img src={IconProfile} alt="" />
                    <span>Entre ou cadastre-se</span>
                  </S.HeaderNavigationItemLink>
                </S.Account>
              )}

              <S.Wrapper>
                {logged && (
                  <S.ProfileMenuList>
                    <li>
                      <S.LinkVoltar href={process.env.REACT_APP_URL_MAIN}>
                        <img src={IconArrowLeft} alt="" />
                        Voltar
                      </S.LinkVoltar>
                    </li>

                    {!!store.user.info?.clienteDiamante && (
                      <li
                        className="diamante"
                        onClick={() =>
                          (window.location.href = `${process.env.REACT_APP_URL_MAIN}/cliente-diamante`)
                        }
                      >
                        <S.Tag>
                          <div className="text">
                            <img src={IconDiamond} alt="" />
                            <p>Cliente Diamante</p>
                          </div>
                          <img
                            className="arrow-right"
                            src={IconArrowRight}
                            alt=""
                          />
                        </S.Tag>
                      </li>
                    )}

                    <li>
                      <Link to="/meu-perfil">Dados de Cadastro</Link>
                    </li>
                    <li>
                      <Link to="/meus-pedidos">Meus Pedidos</Link>
                    </li>
                    <li>
                      <a
                        href={`${process.env.REACT_APP_URL_MAIN}/meuperfil/minhalista`}
                      >
                        Minhas Listas
                      </a>
                    </li>
                    <li>
                      <Link to="/meus-enderecos">Meus Endereços</Link>
                    </li>
                    <li>
                      <Link to="/meus-cartoes">Meus Cartões</Link>
                    </li>
                    <li>
                      <Link to="/gimplus">Gimplus</Link>
                    </li>
                    <li>
                      <Link to="/negociacoes">Negociações</Link>
                    </li>
                    <li>
                      <Link to="/cotacoes">Cotações</Link>
                    </li>
                    {auth.isPF() && isPromotor(user.codigoPromotor) === true ? (
                      <li>
                        <Link to="/vendas-promovidas">Vendas Promovidas</Link>
                      </li>
                    ) : null}

                    {!auth.isPF() && (
                      <li>
                        <a
                          href={`${process.env.REACT_APP_URL_MAIN}/boleto/lista`}
                        >
                          2ª via de Boleto
                        </a>
                      </li>
                    )}

                    {!auth.isPF() && !!store.user.info?.permiteTrocarCliente ? (
                      <li>
                        <a
                          href={`${process.env.REACT_APP_URL_MAIN}/Checkout/SelecionarCadastro`}
                        >
                          Trocar Cliente
                        </a>
                      </li>
                    ) : null}

                    {/* <li>
                      <Link to="/alterar-senha">Alterar Senha</Link>
                    </li> */}
                    <hr />
                    <li>
                      <Link
                        exact
                        to="#"
                        className="perfil-menu-item-link"
                        onClick={() => {
                          auth.logout()

                          return (window.location.href = `${process.env.REACT_APP_URL_MAIN}/MarketPlaceCliente/logout`)
                        }}
                      >
                        Sair
                      </Link>
                    </li>
                  </S.ProfileMenuList>
                )}

                {/* MENU DE CATEGORIAS DESABILITADO*/}

                {/* {logged && isProfileMenuOpen ? (
                  <S.ProfileMenuList>
                    <li>
                      <Link
                        onClick={() => {
                          setIsProfileMenuOpen(false)
                        }}
                        className="link-back"
                      >
                        Voltar
                      </Link>
                    </li>
                    <li>
                      <Link to="/meu-perfil">Dados de Cadastro</Link>
                    </li>
                    <li>
                      <Link to="/meus-pedidos">Meus Pedidos</Link>
                    </li>
                    <li>
                      <Link to="#">Minhas Listas</Link>
                    </li>
                    <li>
                      <Link to="/meus-enderecos">Meus Endereços</Link>
                    </li>
                    <li>
                      <Link to="/meus-cartoes">Meus Cartões</Link>
                    </li>
                    <li>
                      <Link to="/gimplus">Gimplus</Link>
                    </li>
                    <li>
                      <Link to="/negociacoes">Negociações</Link>
                    </li>
                    <li>
                      <Link to="/cotacoes">Cotações</Link>
                    </li>
                    <li>
                      <Link to="/vendas-promovidas">Vendas Promovidas</Link>
                    </li>
                    <li>
                      <Link to="/alterar-senha">Alterar Senha</Link>
                    </li>
                    <li>
                      <Link to="#">Sair</Link>
                    </li>
                  </S.ProfileMenuList>
                ) : (
                  <S.Category
                    className="menu-mobile-category"
                    onClick={openSubCategories}
                  >
                    <S.CategoryMenuList>
                      {categories &&
                        categories.categorias.map(function (item, i) {
                          return (
                            <S.CategoryMenuItem
                              key={i}
                              className={isCategSubmenuOpen ? 'isActive' : ''}
                              onClick={() =>
                                handleClick(item.id, item.subCategorias)
                              }
                            >
                              <Link to="#">{item.nome}</Link>
                            </S.CategoryMenuItem>
                          )
                        })}
                    </S.CategoryMenuList>

                    <S.CategorySubmenuList
                      className={isCategSubmenuOpen ? 'isActive' : ''}
                    >
                      <S.CategorySubmenuItem>
                        <Link
                          to="#"
                          onClick={closeSubCategories}
                          className="link-back"
                        >
                          Voltar
                        </Link>
                      </S.CategorySubmenuItem>

                      {arraySubCategories &&
                        arraySubCategories.map(function (itemSub, i) {
                          return (
                            <S.CategorySubmenuItem
                              key={i}
                              className="header-modal-category-submenu-item"
                            >
                              <Link to={itemSub.textoApoioTituloLink}>
                                {itemSub.nome}
                              </Link>
                            </S.CategorySubmenuItem>
                          )
                        })}
                    </S.CategorySubmenuList>
                  </S.Category>
                )} */}
              </S.Wrapper>
            </S.MenuMobileBox>
          </S.MenuMobileContent>
        </S.Modal>
      ) : null}
    </>
  )
}

export default MenuMobile
